export default __webpack_public_path__ + "static/media/google-books-search-ss.fcccd9da.png";